<div class="container container-cart site_b2c">
  <div class="row justify-content-md-center mt-5">
    <div class="col-6sb mx-auto mb-3">
      <div
        class="block-drop-down-file mx-auto flex align-items-center justify-content-center"
      >
        <div class="block text-center">
          <i class="fas fa-check-circle mb-3"></i>
          <h1>Solicitud de compra generada!</h1>

          <p>Muchas gracias por visitar {{ url }}</p>

          <a
            class="mt-3 link-primary"
            [routerLink]="['/', 'mi-cuenta', 'solicitudes-de-compras']"
          >
            Puede ver sus solicitudes en el menu "Solicitudes de compras" o
            presionar aquí.
          </a>

          <a
            [routerLink]=""
            (click)="inicio()"
            class="mt-5 link-primary w-100 text-center"
          >
            <i class="fas fa-home"></i> Ir al home
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
